/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { Plus, ChevronRight, ChevronDown, ChevronUp } from 'sushiweb/Icons';
import { useDeleteNode, useGetChildNodes } from './apis';
import { ChildNode } from './ChildNode';
import { green } from 'sushiweb/tokens/color';
import { AddEdit } from 'sushiweb/Icons';

export const ParentNode = ({
  node,
  rootId,
  openFormHandler,
  refetchRootNodes,
  refetchParentEnable = false,
  setRefetchParentEnable = () => {},
}) => {
  const [children, setChildren] = useState([]);
  const [nodeId, setNodeId] = useState();
  const [parentNode, setParentNodes] = useState();
  const {
    data: childData,
    isLoading: childNodesLoading,
    refetch: refetchParent,
  } = useGetChildNodes(
    nodeId,
    {
      onSuccess: (childData) => {
        const updatedChildData = [...childData];
        for (let i = 0; i < childData.length; i++) {
          updatedChildData[i].is_collapsed = true;
        }
        setChildren(updatedChildData);
      },
    },
    node,
  );
  const { mutate: deleteNode } = useDeleteNode(
    { method: 'DELETE' },
    refetchRootNodes,
  );

  useEffect(() => {
    if (refetchParentEnable && nodeId) {
      refetchParent();
      setRefetchParentEnable(false);
    }
  }, [refetchParentEnable]);

  useEffect(() => {
    setParentNodes(node);
  }, [node]);

  const callChildren = () => {
    setNodeId(node?.id);
    const updatedParentNode = { ...parentNode };
    const isCollapsed = parentNode.is_collapsed;
    updatedParentNode.is_collapsed = !isCollapsed;
    setParentNodes(updatedParentNode);
  };

  return (
    <div
      className={`tw-flex tw-flex-col tw-w-full  tw-bg-base-white tw-rounded-xl  ${
        node?.root_id === node?.parent_id ? 'tw-rounded-xl' : ''
      } ${!node?.is_collapsed ? 'tw-rounded-b-0' : ''} tw-relative`}
    >
      <div
        className={`tw-flex tw-justify-between tw-py-4 tw-px-5  tw-border-x-0   ${
          node?.root_id === node?.parent_id && parentNode?.is_collapsed
            ? 'hover:tw-rounded-xl'
            : ''
        }   `}
      >
        <div
          className={`tw-text-200  ${
            parentNode?.is_collapsed ? 'tw-font-medium' : 'tw-font-bold'
          }`}
        >
          {node?.title}
        </div>
        <div className='tw-flex tw-gap-3 tw-cursor-pointer'>
          <div onClick={callChildren}>
            {parentNode?.has_children ? (
              parentNode?.is_collapsed ? (
                <ChevronDown size={15} color={'#696969'} />
              ) : (
                <ChevronUp size={15} color={'#696969'} />
              )
            ) : (
              <ChevronRight size={15} color={'#696969'} />
            )}
          </div>
          <span
            className='tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center'
            onClick={() => {
              openFormHandler(
                false,
                node?.parent_id,
                node?.root_id,
                node?.node_type,
                2,
                node?.id,
              );
            }}
          >
            <AddEdit size={12} color={green.z700} />
          </span>
        </div>
      </div>

      {children?.length && !childNodesLoading && !parentNode.is_collapsed ? (
        <div
          className={`tw-flex tw-flex-col  tw-m-5 tw-rounded-xl ${
            parent?.isCollapsed ? '' : 'tw-border-solid tw-border-grey-200'
          }`}
        >
          <div className='tw-flex tw-flex-col '>
            {children.map((child, index) => {
              const CompName = child?.has_children ? ParentNode : ChildNode;
              return (
                <div
                  className={`tw-border-solid tw-border-grey-200 tw-border-t-0 tw-border-x-0 tw-text-black ${
                    index === children?.length - 1 ? 'tw-border-b-0' : ''
                  }`}
                  key={`${child?.id}_${index}`}
                >
                  <CompName
                    node={child}
                    nodeId={child?.id}
                    isLastNode={index === children?.length - 1}
                    openFormHandler={openFormHandler}
                    refetchRootNodes={refetchRootNodes}
                    refetchParentEnable={refetchParentEnable}
                  />
                </div>
              );
            })}
          </div>
        </div>
      ) : null}
      {!parentNode?.is_collapsed && (
        <div
          className={`tw-flex tw-w-full tw-py-4 tw-px-5 tw-bg-base-white  tw-justify-between tw-cursor-pointer   tw-text-green-700 tw-rounded-b-xl tw-rounded-t-0 tw-border-solid tw-border-x-0 tw-border-b-0 tw-border-grey-200`}
          onClick={() => {
            openFormHandler(false, node?.id, rootId, node?.node_type, 1);
          }}
        >
          <div className='tw-text-200 tw-font-bold '>Add more</div>
          <div>
            <Plus size={15} color={'#318616'} />
          </div>
        </div>
      )}
    </div>
  );
};
